export const ATTRIBUTE_LABEL = "Property";

export const ATTRIBUTE_PLURAL_LABEL = "Properties";